import { computed, ref } from 'vue'
import adminNavigationApi from '@/api/adminNavigation'
import type { AttentionItem, AttentionKey } from '@/api/attention'

const items = ref<AttentionItem[]>([])
const available = ref<boolean | null>(null)
let loading: Promise<void> | null = null

async function refreshAttention() {
  if (available.value === false) return
  if (loading) return loading
  loading = adminNavigationApi.getAttention().then(response => {
    items.value = response.items || []
    available.value = true
  }).catch((error: any) => {
    if (error?.status === 404 || error?.response?.status === 404) {
      available.value = false
      items.value = []
    }
  }).finally(() => { loading = null })
  return loading
}

async function markAttentionSeen(key: AttentionKey) {
  if (available.value === false) return
  try {
    await adminNavigationApi.markAttentionSeen(key)
    await refreshAttention()
  } catch (error: any) {
    if (error?.status === 404 || error?.response?.status === 404) {
      available.value = false
      items.value = []
    }
  }
}

export function useAdminAttention() {
  return {
    items,
    available,
    total: computed(() => items.value.reduce((sum, item) => sum + item.count, 0)),
    totalNew: computed(() => items.value.reduce((sum, item) => sum + item.new_count, 0)),
    refreshAttention,
    markAttentionSeen
  }
}
